/* Open the desktop mega menu on hover with a short intent delay; click, tap and keyboard keep working.
   Only runs where a mouse is the primary pointer, so touch screens keep the tap-to-open behaviour. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var OPEN_DELAY = 300, CLOSE_DELAY = 260;
  var items = document.querySelectorAll('.header__inline-menu header-menu');
  Array.prototype.forEach.call(items, function (hm) {
    var details = hm.querySelector('details.mega-menu');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    var li = hm.closest('li') || hm;
    var openTimer = null, closeTimer = null, openedByHover = false;

    function openIt() {
      if (details.open) return;
      // close any sibling panel first so two never stack
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      openedByHover = true;
    }
    function closeIt() {
      if (!details.open) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
      openedByHover = false;
    }
    li.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openTimer = setTimeout(openIt, OPEN_DELAY);
    });
    li.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(closeIt, CLOSE_DELAY);
    });
    // a click on the label while the panel is already open by hover keeps it open instead of toggling it shut
    summary.addEventListener('click', function (e) {
      if (details.open && openedByHover) { e.preventDefault(); openedByHover = false; }
    });
    details.addEventListener('toggle', function () { if (!details.open) openedByHover = false; });
  });
  // leave the whole header: close everything
  var header = document.querySelector('.header__inline-menu');
  if (header) header.addEventListener('mouseleave', function () {
    setTimeout(function () {
      if (header.matches(':hover')) return;
      header.querySelectorAll('details.mega-menu[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); });
    }, CLOSE_DELAY);
  });
})();
